/* BANDUDU · movimiento (13-oct-2026). Sin librerías.
   Principio: el contenido es visible por defecto. Este archivo solo agrega estados
   (aparecer al bajar, brillo de carga, franja en movimiento, rebote del carrito).
   Si algo falla, se quita html.bd-motion y todo queda visible al instante. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  function prefersReduced() {
    return !!(reduceQuery && reduceQuery.matches);
  }

  function revealEverything() {
    root.classList.remove('bd-motion');
  }

  function safe(fn) {
    try {
      fn();
    } catch (error) {
      revealEverything();
      if (window.console && console.warn) console.warn('[bd-motion]', error);
    }
  }

  /* ---------- 1. Aparecer al bajar (listas) ---------- */
  var REVEAL_GROUPS = [
    { list: '.bdh-cat-grid', item: '.bdh-cat' },
    { list: '.bdh-products', item: '.bdh-product' },
    { list: '.bdh', item: '.bdh-help', soft: true },
    { list: '.product-grid', item: '.product-grid__item' }
  ];
  var MAX_STAGGER = 5;

  function isBelowFold(element) {
    return element.getBoundingClientRect().top > window.innerHeight * 0.92;
  }

  function initReveal() {
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        safe(function () {
          var index = 0;
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var element = entry.target;
            element.style.setProperty('--bd-i', String(Math.min(index, MAX_STAGGER)));
            index += 1;
            element.classList.add('bd-in');
            observer.unobserve(element);
            element.addEventListener(
              'animationend',
              function () {
                element.style.removeProperty('--bd-i');
              },
              { once: true }
            );
          });
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
    );

    var marked = 0;
    REVEAL_GROUPS.forEach(function (group) {
      document.querySelectorAll(group.list).forEach(function (list) {
        list.querySelectorAll(group.item).forEach(function (item) {
          // Lo que ya se ve al cargar no se oculta: evita parpadeos.
          if (!isBelowFold(item)) return;
          item.classList.add('bd-reveal');
          if (group.soft) item.classList.add('bd-reveal--soft');
          observer.observe(item);
          marked += 1;
        });
      });
    });

    if (marked > 0) root.classList.add('bd-motion');
  }

  /* ---------- 2. Brillo mientras carga la foto ---------- */
  var SHIMMER_TARGETS = [
    { box: '.bdh-product-media', img: 'img' },
    { box: '.product-grid__item .card-gallery', img: 'img' }
  ];

  function isLoaded(img) {
    return img.complete && img.naturalWidth > 0;
  }

  function attachShimmer(box, img) {
    if (isLoaded(img) || box.querySelector(':scope > .bd-shimmer')) return;
    var shimmer = document.createElement('span');
    shimmer.className = 'bd-shimmer';
    shimmer.setAttribute('aria-hidden', 'true');
    box.appendChild(shimmer);

    var finish = function () {
      shimmer.classList.add('bd-shimmer--out');
      window.setTimeout(function () {
        shimmer.remove();
      }, 350);
    };
    img.addEventListener('load', finish, { once: true });
    img.addEventListener('error', finish, { once: true });
    // Red lenta o imagen que nunca dispara eventos: no dejar el brillo para siempre.
    window.setTimeout(finish, 12000);
  }

  function initShimmer() {
    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          var img = entry.target.querySelector('img');
          if (img) safe(function () { attachShimmer(entry.target, img); });
        });
      },
      { rootMargin: '120px 0px' }
    );

    SHIMMER_TARGETS.forEach(function (target) {
      document.querySelectorAll(target.box).forEach(function (box) {
        var img = box.querySelector(target.img);
        if (img && !isLoaded(img)) observer.observe(box);
      });
    });
  }

  /* ---------- 3. Hero: pausar la flotación cuando no se ve ---------- */
  function initHeroPause() {
    var hero = document.querySelector('.bdh-hero');
    if (!hero || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        hero.classList.toggle('bd-paused', !entry.isIntersecting);
      });
    }).observe(hero);
  }

  /* ---------- 4. Franja de beneficios en movimiento (solo si no cabe) ---------- */
  var MARQUEE_SPEED = 38; // px por segundo: se lee con calma
  var marquee = null;

  function textOverflows(text) {
    var previous = text.style.whiteSpace;
    text.style.whiteSpace = 'nowrap';
    var overflows = text.scrollWidth > text.clientWidth + 2;
    text.style.whiteSpace = previous;
    return overflows;
  }

  function buildMarquee(text) {
    // Conserva la altura que ya tenía la barra: sin salto de diseño (CLS) al armar la franja.
    var keptHeight = Math.ceil(text.getBoundingClientRect().height);
    var original = document.createElement('span');
    original.className = 'bd-marquee__item';
    while (text.firstChild) original.appendChild(text.firstChild);

    var copy = original.cloneNode(true);
    copy.setAttribute('aria-hidden', 'true');

    var track = document.createElement('span');
    track.className = 'bd-marquee__track';
    track.appendChild(original);
    track.appendChild(copy);

    text.appendChild(track);
    text.style.minHeight = keptHeight + 'px';
    text.classList.add('bd-marquee');

    var seconds = Math.max(12, Math.round(original.getBoundingClientRect().width / MARQUEE_SPEED));
    text.style.setProperty('--bd-marquee-dur', seconds + 's');
    return { text: text, track: track, original: original };
  }

  function destroyMarquee(state) {
    var text = state.text;
    while (state.original.firstChild) text.insertBefore(state.original.firstChild, state.track);
    state.track.remove();
    text.classList.remove('bd-marquee');
    text.style.removeProperty('--bd-marquee-dur');
    text.style.removeProperty('min-height');
  }

  function pauseWhenHidden(text) {
    if (!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        text.classList.toggle('bd-marquee--paused', !entry.isIntersecting);
      });
    }).observe(text);
  }

  function syncMarquee() {
    var slides = document.querySelectorAll('.announcement-bar__slide');
    if (slides.length !== 1) return;
    var text = slides[0].querySelector('.announcement-bar__text');
    if (!text) return;

    if (marquee) {
      destroyMarquee(marquee);
      marquee = null;
    }
    if (prefersReduced() || !textOverflows(text)) return;
    marquee = buildMarquee(text);
  }

  function initMarquee() {
    syncMarquee();
    if (marquee) pauseWhenHidden(marquee.text);

    var lastWidth = window.innerWidth;
    var timer = 0;
    window.addEventListener('resize', function () {
      if (window.innerWidth === lastWidth) return; // la barra del navegador móvil cambia el alto, no importa
      lastWidth = window.innerWidth;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        safe(syncMarquee);
      }, 200);
    });
  }

  /* ---------- 5. Ícono del carrito que rebota al agregar ---------- */
  function initCartBump() {
    // Horizon anima la burbuja con la animación "grow"; la escuchamos (sobrevive a re-render del encabezado).
    document.addEventListener('animationstart', function (event) {
      if (event.animationName !== 'grow') return;
      var target = event.target;
      if (!(target instanceof Element) || !target.closest('.cart-bubble')) return;
      var icon = target.closest('cart-icon');
      if (!icon) return;
      icon.classList.remove('bd-bump');
      void icon.offsetWidth; // reinicia la animación si se agregan varios seguidos
      icon.classList.add('bd-bump');
      window.setTimeout(function () {
        icon.classList.remove('bd-bump');
      }, 700);
    });
  }

  function init() {
    if (designMode || prefersReduced()) return;
    safe(initReveal);
    safe(initShimmer);
    safe(initHeroPause);
    safe(initMarquee);
    safe(initCartBump);
  }

  // Si la persona activa "reducir movimiento" con la página abierta: mostrar todo y detener la franja.
  if (reduceQuery && reduceQuery.addEventListener) {
    reduceQuery.addEventListener('change', function () {
      if (!prefersReduced()) return;
      revealEverything();
      safe(syncMarquee);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
